import { cloneDeep } from 'lodash';

export function clone<T>(obj: T): T {
  return cloneDeep(obj);
  // caso a parada acima dê problema, da pra usar a parada abaixo
  // return JSON.parse( FormatUtils.toJson(obj));
}
